var _path, _path2, _path3, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVehicleMoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 0.41748C28.8726 0.417482 34.1219 0.852941 37.7583 4.4751C41.401 8.10526 41.8052 13.3574 41.8052 20.02C41.8052 26.6753 41.4055 31.9226 37.771 35.5542C34.1374 39.1859 28.8836 39.5835 22.2222 39.5835C15.5607 39.5835 10.306 39.1859 6.67236 35.5542C3.03766 31.9234 2.63916 26.6754 2.63916 20.02C2.63916 13.3658 3.03747 8.11925 6.67041 4.48975C10.3052 0.857662 15.5634 0.41748 22.2222 0.41748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 0.41748C28.8726 0.417482 34.1219 0.852941 37.7583 4.4751C41.401 8.10526 41.8052 13.3574 41.8052 20.02C41.8052 26.6753 41.4055 31.9226 37.771 35.5542C34.1374 39.1859 28.8836 39.5835 22.2222 39.5835C15.5607 39.5835 10.306 39.1859 6.67236 35.5542C3.03766 31.9234 2.63916 26.6754 2.63916 20.02C2.63916 13.3658 3.03747 8.11925 6.67041 4.48975C10.3052 0.857662 15.5634 0.41748 22.2222 0.41748Z",
    fill: "url(#paint0_linear_818_13963)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 0.41748C28.8726 0.417482 34.1219 0.852941 37.7583 4.4751C41.401 8.10526 41.8052 13.3574 41.8052 20.02C41.8052 26.6753 41.4055 31.9226 37.771 35.5542C34.1374 39.1859 28.8836 39.5835 22.2222 39.5835C15.5607 39.5835 10.306 39.1859 6.67236 35.5542C3.03766 31.9234 2.63916 26.6754 2.63916 20.02C2.63916 13.3658 3.03747 8.11925 6.67041 4.48975C10.3052 0.857662 15.5634 0.41748 22.2222 0.41748Z",
    stroke: "#F4F4F4",
    strokeWidth: 0.833333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_818_13963)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.2224,
    cy: 22.2224,
    r: 11.1111,
    fill: "#FF9F1A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_818_13963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6294 22.6646H22.6489C23.5869 22.6646 24.3472 23.4257 24.3472 24.3638V31.7485C24.3472 32.6866 23.5869 33.4477 22.6489 33.4478H22.6294C21.6913 33.4478 20.9302 32.6866 20.9302 31.7485V24.3638C20.9302 23.4257 21.6913 22.6646 22.6294 22.6646Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "url(#paint1_linear_818_13963)",
    strokeWidth: 0.606061
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6392 7.38623C23.4471 7.38633 24.1663 7.76721 24.6274 8.35986C24.9205 8.73656 25.3689 8.97119 25.8569 8.97119H27.0474C27.4089 8.97119 27.7228 9.17726 27.8784 9.47998L27.9634 9.64502H30.7183C30.8622 9.64516 30.9789 9.76181 30.979 9.90576C30.979 10.0498 30.8622 10.1664 30.7183 10.1665H27.9634L27.8784 10.3315C27.7228 10.6344 27.409 10.8403 27.0474 10.8403H25.8569C25.3684 10.8403 24.9205 11.075 24.6274 11.4517C24.1663 12.0444 23.4472 12.4252 22.6392 12.4253C21.8309 12.4253 21.1111 12.0446 20.6499 11.4517C20.3569 11.075 19.9093 10.8404 19.4214 10.8403H18.23C17.8683 10.8403 17.5545 10.6345 17.3989 10.3315L17.3149 10.1665H14.5601C14.416 10.1665 14.2983 10.0499 14.2983 9.90576C14.2984 9.76172 14.416 9.64502 14.5601 9.64502H17.3149L17.3989 9.47998C17.5546 9.17719 17.8684 8.97119 18.23 8.97119H19.4214C19.9099 8.97111 20.3569 8.73644 20.6499 8.35986C21.1111 7.76704 21.831 7.38623 22.6392 7.38623ZM22.6392 8.01709C21.602 8.01709 20.7612 8.85787 20.7612 9.89502C20.7613 10.9321 21.602 11.7729 22.6392 11.7729C23.6761 11.7728 24.5161 10.932 24.5161 9.89502C24.5161 8.85798 23.6762 8.01727 22.6392 8.01709Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "url(#paint2_linear_818_13963)",
    strokeWidth: 0.606061
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6382 13.5854C23.7905 13.5878 24.7095 13.6827 25.4438 13.8022L26.1187 13.9282C26.7393 14.0667 27.3492 14.4413 27.8384 14.9526C28.3281 15.4645 28.6785 16.0949 28.8003 16.7212L28.8013 16.7241C28.9649 17.5433 29.1728 19.8788 29.1558 21.4224V21.4292C29.1727 22.9727 28.9649 25.3073 28.8013 26.1265L28.8003 26.1284C28.6787 26.7554 28.3275 27.3868 27.8374 27.8989C27.3482 28.41 26.7382 28.7849 26.1177 28.9233C26.0362 28.9403 25.9507 28.9535 25.8628 28.9702V24.3735C25.8628 22.5952 24.4165 21.1479 22.6382 21.1479C20.8599 21.148 19.4136 22.5952 19.4136 24.3735V28.9702L19.1587 28.9233C18.5381 28.7849 17.9281 28.41 17.439 27.8989C16.9489 27.3868 16.5976 26.7554 16.4761 26.1284L16.4751 26.1265C16.3115 25.3073 16.1036 22.9727 16.1206 21.4292V21.4224C16.1036 19.8788 16.3114 17.5439 16.4751 16.7241L16.4761 16.7222C16.5977 16.0953 16.949 15.4647 17.439 14.9526C17.9281 14.4414 18.5381 14.0667 19.1587 13.9282C19.9815 13.7573 21.1027 13.5881 22.6382 13.5854ZM18.4585 15.7974C18.2214 15.7979 18.044 15.8245 17.9116 15.8521H17.9077C17.7434 15.8885 17.6014 15.9818 17.4966 16.0913C17.3918 16.2009 17.3063 16.3452 17.2749 16.5063C17.2578 16.5923 17.245 16.7633 17.2358 16.9692C17.2262 17.1873 17.2202 17.4706 17.2202 17.7944C17.2202 18.1181 17.2271 18.4008 17.2368 18.6187C17.2461 18.8267 17.2582 18.998 17.2749 19.0825C17.3064 19.2436 17.392 19.3873 17.4966 19.4966C17.6014 19.606 17.7437 19.6993 17.9077 19.7358L17.9116 19.7368C18.0106 19.7573 18.135 19.7778 18.2915 19.7866L18.4595 19.7905C18.6965 19.79 18.874 19.7643 19.0063 19.7368L19.0103 19.7358C19.1746 19.6994 19.3166 19.6062 19.4214 19.4966C19.5263 19.3869 19.6117 19.2428 19.6431 19.0815L19.6421 19.0806C19.659 18.9943 19.673 18.8244 19.6821 18.6196C19.6918 18.4017 19.6978 18.1185 19.6978 17.7944C19.6978 17.4885 19.6909 17.205 19.6812 16.9829C19.6765 16.8777 19.671 16.7799 19.6646 16.6978L19.6431 16.5054C19.6115 16.3444 19.526 16.2005 19.4214 16.0913C19.3167 15.982 19.1751 15.8896 19.0112 15.853V15.8521H19.0063C18.8744 15.8247 18.6976 15.7974 18.4595 15.7974H18.4585ZM26.8169 15.7974C26.5798 15.7979 26.4024 15.8245 26.27 15.8521H26.2661C26.1019 15.8885 25.9598 15.9818 25.855 16.0913C25.7502 16.2009 25.6647 16.3452 25.6333 16.5063C25.6162 16.5923 25.6034 16.7633 25.5942 16.9692C25.5846 17.1873 25.5786 17.4706 25.5786 17.7944C25.5786 18.1181 25.5855 18.4008 25.5952 18.6187C25.5999 18.7227 25.6054 18.8177 25.6118 18.897L25.6333 19.0825C25.6648 19.2436 25.7504 19.3873 25.855 19.4966C25.9597 19.6059 26.1013 19.6993 26.2651 19.7358L26.27 19.7368C26.4019 19.7641 26.5789 19.7905 26.8169 19.7905H26.8179C27.0549 19.79 27.2324 19.7644 27.3647 19.7368L27.3687 19.7358C27.533 19.6994 27.675 19.6062 27.7798 19.4966C27.8846 19.387 27.9701 19.2428 28.0015 19.0815L28.0005 19.0806C28.0174 18.9943 28.0314 18.8244 28.0405 18.6196C28.0502 18.4017 28.0561 18.1185 28.0562 17.7944C28.0562 17.4885 28.0493 17.205 28.0396 16.9829C28.0349 16.8777 28.0294 16.7799 28.0229 16.6978L28.0015 16.5054C27.9699 16.3444 27.8844 16.2005 27.7798 16.0913C27.675 15.9819 27.5327 15.8895 27.3687 15.853V15.8521H27.3647C27.2328 15.8247 27.0552 15.7974 26.8169 15.7974Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "url(#paint3_linear_818_13963)",
    strokeWidth: 0.606061
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_818_13963",
    x: 0.000216484,
    y: 0.000216484,
    width: 44.4444,
    height: 44.4444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.55556,
    result: "effect1_foregroundBlur_818_13963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_818_13963",
    x1: 22.2221,
    y1: 0.000488281,
    x2: 22.2221,
    y2: 40.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B71D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8410",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_818_13963",
    x1: 21.7964,
    y1: 22.9747,
    x2: 28.7452,
    y2: 27.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_818_13963",
    x1: 19.0187,
    y1: 7.38725,
    x2: 20.2443,
    y2: 14.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_818_13963",
    x1: 19.7812,
    y1: 14.1466,
    x2: 29.175,
    y2: 29.4744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_818_13963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26.6667,
    fill: "white",
    transform: "translate(9.30566 7.08398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicleMoto);
export default __webpack_public_path__ + "static/media/icon_vehicle_moto.f2ef75dd290d34fa3b5d214e5ea43ec3.svg";
export { ForwardRef as ReactComponent };